// Founding Merchant pilot terms: the one place the website states them.
// James confirmed limited-place wording on 1 Nov 2026; 3 months free, then £9.99 a month
// for the rest of the first year (not for life), compared with the £29 Starter plan.
// Eligibility, start date and billing are confirmed with each business before activation.
export const PILOT_OFFER = Object.freeze({
  availability: "Limited places",
  freeMonths: 3,
  price: "£9.99",
  standardPrice: "£29",
  standardPlan: "Starter",
  monthlySaving: "£19.01",
  term: "for the rest of your first year",
  whatsappNumber: "07951 706615",
  whatsappUrl: "https://wa.me/447951706615",
  supportEmail: "support@zedipass.com",
});

export default PILOT_OFFER;
